package com.schoolconnect.app.theme

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import org.jetbrains.compose.resources.Font
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.inter_bold
import ischoolconnect.sharedui.generated.resources.inter_light
import ischoolconnect.sharedui.generated.resources.inter_medium
import ischoolconnect.sharedui.generated.resources.inter_regular
import ischoolconnect.sharedui.generated.resources.inter_semibold
import ischoolconnect.sharedui.generated.resources.playfair_display_italic

@Composable
fun interRegular() = FontFamily(Font(Res.font.inter_regular))

@Composable
fun interSemiBold() = FontFamily(Font(Res.font.inter_semibold))

@Composable
fun interMedium() = FontFamily(Font(Res.font.inter_medium))

@Composable
fun interLight() = FontFamily(Font(Res.font.inter_light))

@Composable
fun interBold() = FontFamily(Font(Res.font.inter_bold))

@Composable
fun interItalic() = FontFamily(Font(Res.font.playfair_display_italic))
